<template>
  <v-container fluid>
    <v-btn @click="signIn('identity-server4')">
      Aanmelden
    </v-btn>
  </v-container>
</template>


<script setup lang="ts">

definePageMeta({
  auth: { unauthenticatedOnly: true, navigateAuthenticatedTo: '/navigate' }
})

const { signIn } = useAuth()


</script>
